module.exports = __webpack_public_path__ + "img/我的项目-注意.e4cf4c73.png";